import React, { Fragment } from "react";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import Catalogues from "../../components/Catalogues";


const CataloguesPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const allLoadingStates = [

	];

	const pageIsLoading = genericDataLoaded === false;

	return (
		<Container maxWidth="lg">
			<Catalogues/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};
export default CataloguesPage;
